<template>
  <div>
    <PageTitle
      featureName="services"
      functionName="List"
      :pageName="$options.name"
    />

    <v-container fluid>
      <v-card v-if="openServiceList.length > 0">
        <v-card-title><div class="subtitle-2">Open Services</div></v-card-title>
        <v-card-text>
          <ServiceListItemCard
            v-for="ss in openServiceList"
            :key="ss.ScheduledServiceId"
            :ss="ss"
            @edit="serviceListItemEditEvent"
          />
        </v-card-text>
      </v-card>

      <v-card v-if="closedServiceList.length > 0" class="mt-2">
        <v-card-title
          ><div class="subtitle-2">Closed Services</div></v-card-title
        >
        <v-card-text>
          <ServiceListItemCard
            v-for="ss in closedServiceList"
            :key="ss.ScheduledServiceId"
            :ss="ss"
            @edit="serviceListItemEditEvent"
          />
        </v-card-text>
      </v-card>

      <v-card width="350" class="ma-2 indigo lighten-5">
        <v-card-text>
          <div class="d-flex align-content-space-around flex-wrap">
            <v-card width="320">
              <v-card-text>
                <DatePicker
                  v-model="serviceDate"
                  label="Service Date"
                  clearable
                  dense
                  @change="refreshSearch"
                />
              </v-card-text>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog
      persistent
      v-model="showScheduledServiceEditorDialog"
      :width="feature.services.dialogWidth"
    >
      <ScheduledServiceEditor
        :isDialogOpen="showScheduledServiceEditorDialog"
        :scheduledServiceId="selectedScheduledServiceId"
        @close="scheduledServiceEditorCloseEvent"
        @update="scheduledServiceEditorUpdateEvent"
        @editRecurringService="editRecurringServiceEvent"
      />
    </v-dialog>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { feature, icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import { todayISOString } from '@/use/DateFormatter'
import ScheduledServiceEditor from '@/components/ScheduledService/ScheduledServiceEditor'
import ServiceListItemCard from '@/components/ScheduledService/ServiceListItemCard'
import { userData } from '@/store/UserSession'
export default {
  name: 'ServicesPage',
  components: {
    ScheduledServiceEditor,
    ServiceListItemCard
  },
  setup() {
    const serviceList = ref([])
    const serviceDate = ref(todayISOString())
    const showScheduledServiceEditorDialog = ref(false)
    const selectedScheduledServiceId = ref()

    const openServiceList = computed(() =>
      serviceList.value.filter(svc => svc.Status == 'O')
    )

    const closedServiceList = computed(() =>
      serviceList.value.filter(svc => svc.Status !== 'O')
    )

    const serviceListItemEditEvent = scheduledServiceId => {
      selectedScheduledServiceId.value = scheduledServiceId
      showScheduledServiceEditorDialog.value = true
    }

    const scheduledServiceEditorCloseEvent = () => {
      showScheduledServiceEditorDialog.value = false
    }

    const scheduledServiceEditorUpdateEvent = () => {
      showScheduledServiceEditorDialog.value = false
      refreshSearch()
    }

    const editRecurringServiceEvent = () => {}

    const initForm = () => {
      refreshSearch()
    }

    const refreshSearch = async () => {
      const rq = {
        Criteria: {
          RequestList: [
            {
              UserId: userData.value.UserId,
              ServiceDate: serviceDate.value
            }
          ]
        }
      }
      const rs = await host.scheduledService.cardList(rq)
      if (rs.InfoList.length > 0) {
        serviceList.value = rs.InfoList[0].ServiceItemList
      }
    }

    initForm()

    return {
      feature,
      icon,
      serviceDate,
      openServiceList,
      closedServiceList,
      refreshSearch,
      selectedScheduledServiceId,
      serviceListItemEditEvent,
      scheduledServiceEditorCloseEvent,
      scheduledServiceEditorUpdateEvent,
      editRecurringServiceEvent,
      showScheduledServiceEditorDialog
    }
  }
}
</script>

<style lang="scss" scoped></style>
